<script>
import {mapState} from 'vuex'

import { validateAndSubmit } from '../../../mixins/validateAndSubmit';
import { validationClass } from '../../../mixins/validationClass';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
    data() {
        return {
            i_feel_close_to_achieving_my_vision: 0,
            form: this.vision,
            disableOnSubmit : false,
        }
    },

    props: ['url', 'vision', 'scaleUrl', 'scale'],

    mixins: [validateAndSubmit, validationClass],

    computed: {
    },

    created() {
    },

    mounted() {
        this.i_feel_close_to_achieving_my_vision = this.scale;
    },

    watch: {
    },

    methods: {
        updateScale() {
            axios
                .put(this.scaleUrl,
                    {
                        scale: this.i_feel_close_to_achieving_my_vision,
                    }
                )
                .then(response => {
                    this.$root.$refs.toastr.s(response.data.message);
                })
                .catch(error => {
                    console.log(error);
                    this.$root.$refs.toastr.e("ERROR");
                });
        },
    },

    components: {
        VueSlider
    }
}
</script>
